import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('../views/ForgetView.vue')
  },
  {
    path: '/index', component: () => import('../views/HomeView.vue'), meta: { title: "首页" }, children: [
      {
        path: 'business/user',
        name: 'business-user',
        component: () => import('../views/business/BusinessList.vue')
      },
      {
        path: 'business/detail',
        name: 'business-detail',
        component: () => import('../views/business/BusinessDetail.vue')
      },
      {
        path: 'business/recharge',
        name: 'business-recharge',
        component: () => import('../views/business/BusinessRecharge.vue')
      },
      {
        path: 'coupons/list',
        name: 'coupons-list',
        component: () => import('../views/coupons/CouponList.vue')
      },
      {
        path: 'coupons/detail',
        name: 'coupons-detail',
        component: () => import('../views/coupons/CouponDetail.vue')
      },
      {
        path: 'coupons/audit',
        name: 'coupons-audit',
        component: () => import('../views/coupons/CouponAudit.vue')
      },
      {
        path: 'customer/list',
        name: 'customer-list',
        component: () => import('../views/customer/CustomerList.vue')
      },
      {
        path: 'customer/detail',
        name: 'customer-detail',
        component: () => import('../views/customer/CustomerDetail.vue')
      },
      {
        path: 'customer/use',
        name: 'customer-use',
        component: () => import('../views/customer/UseDetail.vue')
      },
      {
        path: 'advertise/list',
        name: 'advertise-list',
        component: () => import('../views/advertise/AdvertiseList.vue')
      },
      {
        path: 'advertise/create',
        name: 'advertise-create',
        component: () => import('../views/advertise/CreateAdvertise.vue')
      },
      {
        path: 'advertise/detail',
        name: 'advertise-detail',
        component: () => import('../views/advertise/AdvertiseDetail.vue')
      },
      {
        path: 'case/list',
        name: 'case-list',
        component: () => import('../views/case/CaseList.vue')
      },
      {
        path: 'case/create',
        name: 'case-create',
        component: () => import('../views/case/CreatCase.vue')
      },
      {
        path: 'case/detail',
        name: 'case-detail',
        component: () => import('../views/case/CaseDetail.vue')
      },
      {
        path: 'message/list',
        name: 'message-list',
        component: () => import('../views/message/MessageList.vue')
      },
      {
        path: 'message/detail',
        name: 'message-detail',
        component: () => import('../views/message/MessageDetail.vue')
      },
      {
        path: 'team/list',
        name: 'team-list',
        component: () => import('../views/team/TeamList.vue')
      },
      {
        path: 'team/add',
        name: 'team-add',
        component: () => import('../views/team/AddMember.vue')
      },
      {
        path: 'team/logs',
        name: 'team-logs',
        component: () => import('../views/team/TeamLogs.vue')
      },
      {
        path: 'data/center',
        name: 'data-center',
        component: () => import('../views/data/DataCenter.vue')
      },
      {
        path: 'personal/center',
        name: 'personal-center',
        component: () => import('../views/personal/PersonalCenter.vue')
      },
    ]

  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
